import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import type { ReportTemplate } from '~/exportReport/template/reportTemplate';
import { useModal } from '~/modal/useModal.hook';
import {
  exportReportEnable, exportReportSetTemplate,
} from '~/store/mapSettings/toolsState/exportReport/exportReportToolState.actionCreators';
import type { ExportReportActiveParams } from '~/store/mapSettings/toolsState/exportReport/exportReportToolState.state';

export const useExportReport = () => {
  const { replaceCurrentModal: openExportReportTemplateSelectorModal } = useModal('ExportReportTemplateSelector');
  const { replaceCurrentModal: openExportReportPreviewModal } = useModal('ExportReportPreview');
  const dispatch = useDispatch();

  const openExportReport = useCallback((params: ExportReportActiveParams) => {
    dispatch(exportReportEnable(params));

    openExportReportTemplateSelectorModal({});
  }, [dispatch, openExportReportTemplateSelectorModal]);

  const selectReportTemplate = useCallback((template: ReportTemplate) => {
    dispatch(exportReportSetTemplate(template));
    openExportReportPreviewModal({});
  }, [dispatch, openExportReportPreviewModal]);

  return {
    openExportReport,
    selectReportTemplate,
  };
};
